import { render, staticRenderFns } from "./notificationBarTitle.vue?vue&type=template&id=aa2d520e&"
import script from "./notificationBarTitle.vue?vue&type=script&lang=js&"
export * from "./notificationBarTitle.vue?vue&type=script&lang=js&"
import style0 from "./notificationBarTitle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports